import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from "@angular/core";
import moment from "moment";
import { CommonRegExpPattern } from "../../../../edtell-portal/enums/common-regexp-pattern.enum";
import { SrsFormElement } from "../../../abstracts/srs-form-element.abstract";
import { SrsFormState } from "../../../enumerations/form-state.enum";
import { toJSDate } from "../../../functions/date-parse.function";
import { srsFormatDate } from "../../../functions/srs-format-date.func";
import { SrsDateTimePickerConfig } from "../../../interfaces/elements/srs-datetime-picker-config";

/**
 * @deprecated
 * use EdtellDatetimePickerComponent
 */
@Component({
  selector: "app-srs-datetime-picker",
  templateUrl: "./srs-datetime-picker.component.html",
  styleUrls: ["./srs-datetime-picker.component.scss"],
})
export class SrsDatetimePickerComponent extends SrsFormElement<SrsDateTimePickerConfig> {
  dateValue: Date;
  @Output()
  change = new EventEmitter<any>();

  pattern = CommonRegExpPattern.DATE;

  @ViewChild("dateInput", { static: false }) dateInput: ElementRef;

  readValue;

  constructor() {
    super();
  }

  onElementInit() {
    // This separate date value is being used to make the datePicker happy by giving it a JS date while still maintaining the DB date in the form control
    this.dateValue = toJSDate(this.control.value);
    this.control.valueChanges.subscribe(() => {
      this.dateValue = toJSDate(this.control.value);
      if (this.control.value != null) {
        this.control.markAsTouched();
      }
    });

    if (this.control.value != null) {
      this.readValue = srsFormatDate(this.control.value);
    } else {
      this.readValue = "";
    }

    this.config.group.onStateChange().subscribe((state) => {
      if (state == SrsFormState.READ) {
        if (this.control.value != null) {
          this.readValue = srsFormatDate(this.control.value);
        } else {
          this.readValue = "";
        }
      }
    });
  }

  onChange(event: any) {
    this.doChangeEvent(event.target.value);
  }

  onInput(event: any) {
    this.config.onInput != null ? this.config.onInput(this.control) : null;
  }

  onDateChange(event) {
    this.doChangeEvent(this.dateInput.nativeElement.value);

    this.onInput(event);
  }

  doChangeEvent(date: string) {
    const dbValue = this.toDBDate(date);
    this.control.setValue(dbValue);
    this.config.onChange != null ? this.config.onChange(this.control) : null;
  }

  // Cannot replace this toDBDate function with the generic one since it has an important null check necessary for the picker to work properly
  // Otherwise it would throw "Invalid Dates"
  toDBDate(date) {
    if (!date) {
      return null;
    }

    const split = date.split("/");
    date = `${split[2]}-${split[0]}-${split[1]}`;
    const momentDate = moment(date).format("YYYY-MM-DD");
    return momentDate;
  }

  get min() {
    // this needs to be plus 1 day, idk why, datepickers are weird
    return this.config.min
      ? moment(this.config.min()).add(1, "d").format("YYYY-MM-DD")
      : null;
  }

  get max() {
    // this needs to be plus 1 day, idk why, datepickers are weird
    return this.config.max
      ? moment(this.config.max()).add(1, "d").format("YYYY-MM-DD")
      : null;
  }
}
